import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Linkedin } from 'lucide-react';
import { MapleLeaf } from '@/components/common/MapleLeaf';

const CorporateFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="mt-24 w-full border-t border-border/60 bg-background/80 px-4 py-12 backdrop-blur"
    >
      <div className="grid w-full grid-cols-1 gap-10 text-left md:grid-cols-3">
        <div className="flex flex-col items-start">
          <Link to="/" className="mb-4 flex items-center">
            <MapleLeaf size={32} className="mr-2 text-canada-red" />
            <span className="text-2xl font-bold text-foreground">CanXP AI</span>
          </Link>
          <p className="max-w-sm text-sm leading-6 text-muted-foreground">
            Sovereign AI infrastructure, private deployment, and model engineering for governments, enterprises,
            healthcare organizations, universities, and industrial teams.
          </p>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">Explore</h3>
          <ul className="space-y-2">
            <li>
              <a href="/#services" className="text-muted-foreground transition-colors hover:text-primary">
                Services
              </a>
            </li>
            <li>
              <a href="/#sovereign-compute-network" className="text-muted-foreground transition-colors hover:text-primary">
                Infrastructure & Sovereignty
              </a>
            </li>

            <li>
              <Link to="/research" className="text-muted-foreground transition-colors hover:text-primary">
                Research CLI
              </Link>
            </li>
            <li>
              <Link to="/reports" className="text-muted-foreground transition-colors hover:text-primary">
                Reports
              </Link>
            </li>
            <li>
              <Link to="/enterprise" className="text-muted-foreground transition-colors hover:text-primary">
                Enterprise
              </Link>
            </li>

            <li>
              <Link to="/privacy" className="text-muted-foreground transition-colors hover:text-primary">
                Privacy & Jurisdiction
              </Link>
            </li>
            <li>
              <a href="/llms.txt" className="text-muted-foreground transition-colors hover:text-primary">
                llms.txt
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">Contact</h3>
          <p className="text-sm leading-6 text-muted-foreground">
            Discuss enterprise deployment, sovereign infrastructure, model training, or rollout planning.
            <br />
            Email <a href="mailto:support@canxp.ai" className="text-primary hover:underline">support@canxp.ai</a>
          </p>
          <div className="mt-6">

            <h4 className="mb-2 text-md font-semibold text-foreground">Follow CanXP AI</h4>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/canxp-ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground transition-colors hover:text-primary"
                aria-label="CanXP AI LinkedIn"
              >
                <Linkedin size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8 border-t border-border/60 pt-8 text-center text-sm text-muted-foreground">
        &copy; {currentYear} CanXP AI. Sovereign AI infrastructure and engineering.
      </div>
    </motion.footer>
  );
};

export default CorporateFooter;
